module.exports = __webpack_public_path__ + "img/1F1E9-1F1EF.3481332b.svg";